<template>
    <div class="Appointmentallocation">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.UserInfo" placeholder="请输入用户编号/昵称/手机号" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">咨询方式</label>
                    <el-select v-model="param.ConsultType" placeholder="请选择" class="autowidth" clearable >
                        <el-option label="线下" :value="0"></el-option>
                        <el-option label="线上" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">下单时间</label>
                    <el-date-picker
                    v-model="OrderTime"
                    class="autowidth" 
                    clearable
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="16">
                    <label class="headerlabel">期望咨询时间</label>
                    <el-date-picker
                    v-model="param.ExpectedTime"
                    class="autowidth" 
                    clearable
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>

                    <el-button type="primary" style="margin-left: 24px;" @click="handleinitialization(1)">筛选</el-button>
                    <el-button @click="react">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="Appointment"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%">
                <el-table-column prop="userID" label="用户ID"></el-table-column>
                <el-table-column prop="realName" label="用户昵称"></el-table-column>
                <el-table-column prop="consultType" label="咨询方式"></el-table-column>
                <el-table-column prop="expectedTimeStr" label="期望咨询时间"></el-table-column>
                <el-table-column prop="consultTheme" label="咨询类目"></el-table-column>
                <el-table-column prop="consultCntIntroduce" label="问题描述"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>
                <el-table-column prop="createdDateStr" label="下单时间"></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button  v-if="scope.row.status==0" type="text" @click="Edit(scope.row)">分配</el-button>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-drawer
        title="预约详情"
        :visible.sync="drawer"
        >
            <el-form class="Appointmentdetails">
                <el-form-item label="来访者：">
                    <el-input v-model="Appointmentdetails.realName" disabled clearable style="width: 240px;"></el-input>
                </el-form-item>
                <el-form-item label="咨询方式：">
                    <el-input v-model="Appointmentdetails.consultType" disabled clearable style="width: 240px;"></el-input>
                </el-form-item>
                <el-form-item label="咨询日期：">
                    <el-date-picker
                    v-model="Appointmentdetails.expectedTimeStr"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="咨询时段：">
                    <div class="periodtime">
                        <label v-for="(item,index) in Consultationperiod" :key="index" :class="periodaaTime==item?'on':''" @click="periodaaTime=item">{{item.StartTime}}</label>
                    </div>
                </el-form-item>
                <el-form-item label="咨询师：" v-if="periodaaTime">
                    <div class="periodtime">
                        <div class="item" v-for="item in consultantslist" :key="item.UserID" :class="ChooseConsultation==item.ConsultSchID?'on':''" @click="ChooseConsultation=item.ConsultSchID">
                            <el-image :src="item.zheadPhotoURL" fit="contain"></el-image>
                            <p>{{ item.RealName }}</p>
                            <i class="el-icon-success"></i>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item style="margin-top: 100px;text-align:center;">
                    <el-button type="primary" @click="allocation">确认分配</el-button>
                    <el-button @click="drawer=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            drawer:false,
            OrderTime:[],
            organizationId:this.$route.query.organizationId,
            periodaaTime:'',
            Appointmentdetails:'',
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                OrgCode:'',//机构编号
                UserInfo:'',//用户信息
                ConsultType:'',//咨询方式
                From:'',
                To:'',
                ExpectedTime:''
            },
            Consultationperiod:[],
            consultantslist:[],
            url:require('@/assets/fbfgd.png'),
            Appointment: [],
            ChooseConsultation:''
        }
    },
    watch:{
        OrderTime(newval,oldval){
            if(newval==null){
                this.param.From='';
                this.param.To='';
            }else{
                this.param.From=newval[0];
                this.param.To=newval[1];
            }
        },
        'Appointmentdetails.expectedTimeStr'(newval){
            if(this.drawer){
                this.GetSchedulListAPP();
            }
        },
        periodaaTime(newval,oldval){
            this.consultantslist=[];
            for(let item of this.Consultationperiod){
                if(item.StartTime==newval.StartTime){
                    for(let items of item.TimeScheduls){
                        if(items.Status==0){
                            this.consultantslist.push(items);
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.organizationId=this.organizationId?this.organizationId:JSON.parse(sessionStorage.getItem('xinxi')).OrgCode;
        this.init();
    },
    methods: {
        init(){
            this.loading=true;
            this.param.OrgCode=this.organizationId;
            this.$Http_Post('/ConsultSubscribe/GetAppointmentOrgList',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.Appointment=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        // 打开弹窗并获取可预约时间段
        Edit(val){
            this.drawer=true;
            this.$Http_Post('/ConsultSubscribe/GetAppointmentOrgInfo',{AppointmentOrgKey:val.appointmentOrgKey}).then(res=>{
                if(res.Code==0){
                    this.Appointmentdetails=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        GetSchedulListAPP(){
            let map = new Map();
            this.$Http_Post('/ConsultAppoint/GetSchedulListAPP',{UserID:this.Appointmentdetails.userID,ScheduleDate:this.Appointmentdetails.expectedTimeStr,ConsultType:this.Appointmentdetails.consultType=='线下咨询'?0:1,Counselor:"",Campus:"",AppointmentID:"0",SASResult:"0",SDSResult:"0",}).then(res=>{
                if(res.Code==0){
                    this.Consultationperiod=res.Data.DayInfo;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 分配
        allocation(){
            let SubmitParams={
                UserID:this.Appointmentdetails.userID,
                ConsultType:this.Appointmentdetails.consultType=='线下咨询'?0:1,
                ConsultSchID:this.ChooseConsultation,
                AppointmentOrgKey:this.Appointmentdetails.appointmentOrgKey,
                SASResult:0,
                SDSResult:0,
                SASPaperResultID:0,
                SDSPaperResultID:0,
                AppointmentID:0
            };
            if(this.ChooseConsultation==''){
                this.$message({type: 'error', message:"请选择咨询师或者咨询时间"});
                return false;
            }
            this.$Http_Post('/ConsultAppoint/SubmitConsultAPP',SubmitParams).then(res=>{
                if(res.Code==0){
                    this.drawer=false;
                    this.Appointmentdetails='';
                    this.ChooseConsultation='';
                    this.consultantslist=[]
                    this.$message({type: 'success', message:res.Message});
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        react(){
            this.param={
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                OrgCode:'',//机构编号
                UserInfo:'',//用户信息
                ConsultType:'',//咨询方式
                From:'',
                To:'',
                ExpectedTime:''
            };
            this.init();
        }
    },
}
</script>
<style>
.Appointmentallocation .header{background: #fff;padding:20px;}
.Appointmentallocation .header .headerlabel{width:90px;display: inline-block;}
.Appointmentallocation .header .autowidth{width: 240px;}
.Appointmentallocation .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Appointmentallocation .Appointmentdetails{margin:0 20px;}
.Appointmentallocation .el-drawer__header{margin: 0;font-weight: bold;color: #000;font-size: 20px;}
.Appointmentallocation .Appointmentdetails .el-form-item__label{display: block;width: 100%;text-align: left;}
.Appointmentallocation .Appointmentdetails .el-form-item{margin: 0;}
.Appointmentallocation .Appointmentdetails .periodtime{display: flex;flex-wrap: wrap;width: 100%;}
.Appointmentallocation .Appointmentdetails .periodtime label{color: #5C5C5C;padding: 9px 16px;border-radius: 4px;border: 1px solid #8D8D8D;margin:0 16px 16px 0;cursor: pointer;line-height: 1;}
.Appointmentallocation .Appointmentdetails .periodtime label.on{background: #0088FF;border-color: #0088FF;color: #fff;}
.Appointmentallocation .Appointmentdetails .periodtime .item{text-align: center;margin:0 30px 20px 0;position: relative;}
.Appointmentallocation .Appointmentdetails .periodtime .item .el-image{background: #000;width: 80px; height: 80px;border-radius: 50%;}
.Appointmentallocation .Appointmentdetails .periodtime .item i{display: none;}
.Appointmentallocation .Appointmentdetails .periodtime .item.on i{position: absolute;top: 50%;left: 50%;font-size:24px;color: #0088FF;margin:-24px 0px 0 -12px;display: block;}
.Appointmentallocation .Appointmentdetails .periodtime .item p{line-height: 1;}
</style>